/* =========================================================
   VIAPELO — theme.js
   ========================================================= */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const settings = window.vpSettings || {};
  const routes = window.vpRoutes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || settings.moneyFormat || '€{{amount_with_comma_separator}}';
    const num = (n, d, ts, ds) => {
      if (isNaN(n) || n == null) return 0;
      const fixed = (n / 100).toFixed(d);
      const parts = fixed.split('.');
      const ints = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + ts);
      return ints + (parts[1] ? ds + parts[1] : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return num(cents, 2, ',', '.');
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        default: return num(cents, 2, '.', ',');
      }
    });
  }
  window.vpFormatMoney = formatMoney;

  /* ---------- Announcement ---------- */
  $$('[data-announce]').forEach((el) => {
    const items = $$('.announce__item', el);
    if (items.length < 2 || reduced) return;
    let i = 0;
    setInterval(() => {
      const cur = items[i];
      cur.classList.add('is-leaving');
      cur.classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.remove('is-leaving');
      items[i].classList.add('is-active');
      setTimeout(() => cur.classList.remove('is-leaving'), 700);
    }, 4200);
  });

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    const toggle = $('[data-menu-toggle]', header);
    toggle && toggle.addEventListener('click', () => {
      const open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
    $$('.header__nav a', header).forEach((a) => a.addEventListener('click', () => {
      header.classList.remove('is-open');
      toggle && toggle.setAttribute('aria-expanded', 'false');
    }));
  }

  /* ---------- Split words ---------- */
  $$('[data-split]').forEach((el) => {
    let i = 0;
    const walk = (node) => {
      Array.from(node.childNodes).forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            const s = document.createElement('span');
            s.className = 'w';
            s.style.setProperty('--i', i++);
            s.textContent = part;
            frag.appendChild(s);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && !n.classList.contains('scribble')) {
          walk(n);
        } else if (n.nodeType === 1) {
          n.classList.add('w');
          n.style.setProperty('--i', i++);
        }
      });
    };
    walk(el);
  });

  /* ---------- Reveal ---------- */
  const revealIO = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  $$('[data-reveal]').forEach((el) => revealIO.observe(el));

  /* ---------- Autoplay videos when visible ---------- */
  const vidIO = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      const v = en.target;
      if (en.isIntersecting) {
        if (v.preload === 'none') v.preload = 'auto';
        const p = v.play();
        p && p.catch(() => {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.25 });
  $$('video[data-autoplay]').forEach((v) => { v.muted = true; vidIO.observe(v); });

  /* ---------- Before / after ---------- */
  $$('[data-ba]').forEach((el) => {
    const range = $('[data-ba-range]', el);
    const set = (v) => el.style.setProperty('--pos', `${v}%`);
    range.addEventListener('input', () => set(range.value));
    // piccolo "invito" animato quando entra in vista
    if (!reduced) {
      const io = new IntersectionObserver((en) => {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        let t0 = null;
        const anim = (t) => {
          if (!t0) t0 = t;
          const k = Math.min(1, (t - t0) / 1600);
          const v = 50 + Math.sin(k * Math.PI * 2) * 22 * (1 - k);
          set(v);
          range.value = v;
          if (k < 1) requestAnimationFrame(anim);
        };
        requestAnimationFrame(anim);
      }, { threshold: 0.6 });
      io.observe(el);
    }
  });

  /* ---------- How it works (sticky steps) ---------- */
  $$('[data-how]').forEach((sec) => {
    const steps = $$('[data-how-step]', sec);
    const media = $$('[data-how-media]', sec);
    const bar = $('[data-how-bar]', sec);
    const activate = (i) => {
      steps.forEach((s, j) => s.classList.toggle('is-active', i === j));
      media.forEach((m, j) => {
        const on = i === j;
        m.classList.toggle('is-active', on);
        const v = m.querySelector('video');
        if (v) {
          if (on) { if (v.preload === 'none') v.preload = 'auto'; v.currentTime = 0; const p = v.play(); p && p.catch(() => {}); }
          else v.pause();
        }
      });
      if (bar) bar.style.width = `${((i + 1) / steps.length) * 100}%`;
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) activate(+en.target.dataset.howStep); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach((s) => io.observe(s));
  });

  /* ---------- Calculator ---------- */
  $$('[data-calc]').forEach((el) => {
    const range = $('[data-calc-range]', el);
    const uses = $('[data-calc-uses]', el);
    const sheetsEl = $('[data-calc-sheets]', el);
    const refillsEl = $('[data-calc-refills]', el);
    const costEl = $('[data-calc-cost]', el);
    const saveEl = $('[data-calc-save]', el);
    const spu = +el.dataset.sheetsPerUse || 3;
    const spr = +el.dataset.sheetsPerRefill || 60;
    const price = +el.dataset.refillPrice || 250;
    const ours = +el.dataset.ourPrice || 0;
    let shown = { sheets: 0, cost: 0 };
    const tween = (from, to, cb) => {
      if (reduced) { cb(to); return; }
      const t0 = performance.now();
      const f = (t) => {
        const k = Math.min(1, (t - t0) / 500);
        const e = 1 - Math.pow(1 - k, 3);
        cb(from + (to - from) * e);
        if (k < 1) requestAnimationFrame(f);
      };
      requestAnimationFrame(f);
    };
    const update = () => {
      const u = +range.value;
      uses.textContent = u;
      range.style.setProperty('--fill', `${((u - 1) / 13) * 100}%`);
      const sheets = u * 52 * spu;
      const refills = Math.ceil(sheets / spr);
      const cost = refills * price;
      refillsEl.textContent = refills;
      tween(shown.sheets, sheets, (v) => { sheetsEl.textContent = Math.round(v).toLocaleString('it-IT'); });
      tween(shown.cost, cost, (v) => { costEl.textContent = formatMoney(Math.round(v)); });
      shown = { sheets, cost };
      if (saveEl) {
        const diff = cost - ours;
        const weeks = (ours / cost) * 52;
        saveEl.textContent = diff > 0 ? (weeks > 9 ? `Si ripaga in circa ${Math.round(weeks / 4.33)} mesi` : `Si ripaga in circa ${Math.max(1, Math.round(weeks))} settimane`) : '';
      }
    };
    range.addEventListener('input', update);
    const io = new IntersectionObserver((en) => { if (en[0].isIntersecting) { io.disconnect(); update(); } }, { threshold: 0.3 });
    io.observe(el);
  });

  /* ---------- Gallery ---------- */
  $$('[data-gallery]').forEach((g) => {
    const track = $('[data-gallery-track]', g);
    const slides = $$('.gallery__slide', track);
    const thumbs = $('[data-gallery-thumbs]', g);
    const dots = $('[data-gallery-dots]', g);
    slides.forEach((s, i) => {
      const media = s.querySelector('img, video');
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'gallery__thumb';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', `Immagine ${i + 1}`);
      if (media && media.tagName === 'IMG') {
        const im = document.createElement('img');
        im.src = media.currentSrc || media.src;
        im.alt = '';
        im.loading = 'lazy';
        b.appendChild(im);
      } else if (media) {
        const im = document.createElement('img');
        im.src = media.getAttribute('poster') || '';
        im.alt = '';
        b.appendChild(im);
      }
      b.addEventListener('click', () => track.scrollTo({ left: s.offsetLeft, behavior: reduced ? 'auto' : 'smooth' }));
      thumbs && thumbs.appendChild(b);
      if (dots) dots.appendChild(document.createElement('span'));
    });
    const tb = thumbs ? $$('button', thumbs) : [];
    const ds = dots ? $$('span', dots) : [];
    const sync = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      tb.forEach((b, j) => b.setAttribute('aria-selected', i === j));
      ds.forEach((d, j) => d.classList.toggle('is-active', i === j));
    };
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      if (e.key === 'ArrowLeft') track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
    sync();
  });

  /* ---------- Delivery estimate ---------- */
  const addBusinessDays = (date, n) => {
    const d = new Date(date);
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  };
  $$('[data-delivery-range]').forEach((el) => {
    const min = +settings.deliveryMin || 5;
    const max = Math.max(min, +settings.deliveryMax || 10);
    const f = new Intl.DateTimeFormat('it-IT', { weekday: 'short', day: 'numeric', month: 'short' });
    const a = addBusinessDays(new Date(), min);
    const b = addBusinessDays(new Date(), max);
    el.textContent = `tra ${f.format(a)} e ${f.format(b)}`;
  });

  /* ---------- Buy forms: variant selection ---------- */
  $$('[data-buy]').forEach((buy) => {
    const json = $('[data-variants]', buy);
    const variants = json ? JSON.parse(json.textContent) : [];
    const form = $('form', buy);
    const priceLabel = $('[data-atc-price]', buy);
    const atc = $('[data-atc]', buy);
    $$('[data-variant-input]', buy).forEach((input) => {
      if (input.type !== 'radio') return;
      input.addEventListener('change', () => {
        $$('.bundle', buy).forEach((b) => b.classList.toggle('is-active', b.contains(input)));
        const v = variants.find((x) => String(x.id) === input.value);
        if (!v) return;
        if (priceLabel) priceLabel.textContent = formatMoney(v.price);
        if (atc) atc.disabled = !v.available;
        if (buy.dataset.uid === 'main') {
          const pdp = $('[data-pdp]');
          if (pdp) {
            const p = $('[data-price]', pdp), c = $('[data-compare]', pdp), s = $('[data-save]', pdp), sp = $('[data-sticky-price]', pdp);
            if (p) p.textContent = formatMoney(v.price);
            if (sp) sp.textContent = formatMoney(v.price);
            if (c && s) {
              const has = v.compare_at_price && v.compare_at_price > v.price;
              c.hidden = !has; s.hidden = !has;
              if (has) { c.textContent = formatMoney(v.compare_at_price); s.textContent = `-${Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100)}%`; }
            }
          }
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
    form && form.addEventListener('submit', (e) => {
      e.preventDefault();
      addToCart(form, atc);
    });
  });

  /* ---------- Sticky ATC ---------- */
  const sticky = $('[data-sticky-atc]');
  const mainAtc = $('[data-buy][data-uid="main"] [data-atc]');
  if (sticky && mainAtc) {
    const io = new IntersectionObserver((en) => {
      const show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', !show);
    });
    io.observe(mainAtc);
    $('[data-sticky-buy]', sticky).addEventListener('click', () => {
      const form = mainAtc.closest('form');
      addToCart(form, $('[data-sticky-buy]', sticky));
    });
  }

  /* ---------- Cart (AJAX) ---------- */
  const drawer = $('[data-cart-drawer]');
  const itemsEl = drawer && $('[data-cart-items]', drawer);
  let lastFocus = null;

  function openDrawer() {
    if (!drawer) { window.location.href = routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => $('.drawer__panel', drawer).focus(), 50);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
  $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
    if (!drawer) return;
    e.preventDefault();
    refreshCart().then(openDrawer);
  }));

  const imgUrl = (url, w) => {
    if (!url) return '';
    return url + (url.includes('?') ? '&' : '?') + 'width=' + w;
  };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const icon = (name) => {
    const paths = { plus: 'M12 5v14M5 12h14', minus: 'M5 12h14' };
    return `<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="${paths[name]}"/></svg>`;
  };

  function renderCart(cart) {
    $$('[data-cart-count]').forEach((c) => {
      c.textContent = cart.item_count;
      c.classList.toggle('is-empty', cart.item_count === 0);
      c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
    });
    if (!drawer) return;
    const foot = $('[data-cart-foot]', drawer);
    if (!cart.items.length) {
      const pet = document.querySelector('.hero__cat svg, .footer__pets svg');
      itemsEl.innerHTML = `<div class="drawer__empty">${pet ? pet.outerHTML : ''}<p>Il carrello è vuoto. Il cappotto, probabilmente, no.</p><button type="button" class="btn btn--primary" data-cart-close>Continua</button></div>`;
      $('[data-cart-close]', itemsEl).addEventListener('click', closeDrawer);
      foot.hidden = true;
    } else {
      foot.hidden = false;
      itemsEl.innerHTML = cart.items.map((it, idx) => `
        <div class="line" data-line="${idx + 1}">
          ${it.image ? `<img class="line__img" src="${esc(imgUrl(it.image, 200))}" alt="" width="76" height="76" loading="lazy">` : '<span class="line__img"></span>'}
          <div>
            <a class="line__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
            ${it.variant_title && !it.product_has_only_default_variant ? `<div class="line__variant">${esc(it.variant_title)}</div>` : ''}
            <div class="line__qty">
              <button type="button" data-qty="${it.quantity - 1}" aria-label="Diminuisci">${icon('minus')}</button>
              <span>${it.quantity}</span>
              <button type="button" data-qty="${it.quantity + 1}" aria-label="Aumenta">${icon('plus')}</button>
            </div>
          </div>
          <div>
            <div class="line__price">${formatMoney(it.final_line_price)}</div>
            <button type="button" class="line__remove" data-qty="0">Rimuovi</button>
          </div>
        </div>`).join('');
      $$('[data-qty]', itemsEl).forEach((b) => b.addEventListener('click', () => {
        const line = +b.closest('[data-line]').dataset.line;
        changeLine(line, +b.dataset.qty);
      }));
    }
    const sub = $('[data-cart-subtotal]', drawer);
    if (sub) sub.textContent = formatMoney(cart.total_price);
    const th = +settings.freeShipping || 0;
    const fill = $('[data-ship-fill]', drawer), txt = $('[data-ship-text]', drawer);
    if (th > 0 && fill && txt) {
      const left = th - cart.total_price;
      fill.style.width = `${Math.min(100, (cart.total_price / th) * 100)}%`;
      txt.innerHTML = left > 0 ? `Ti mancano <strong>${formatMoney(left)}</strong> per la spedizione gratuita` : '<strong>Hai la spedizione gratuita</strong>';
    }
  }

  function refreshCart() {
    return fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json()).then((c) => { renderCart(c); return c; })
      .catch(() => null);
  }

  function changeLine(line, quantity) {
    return fetch(`${routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity: Math.max(0, quantity) })
    }).then((r) => r.json()).then(renderCart).catch(() => refreshCart());
  }

  function addToCart(form, btn) {
    if (!form) return;
    btn && btn.classList.add('is-loading');
    fetch(`${routes.cartAdd}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.description || data.message || 'Errore');
        return refreshCart();
      })
      .then(() => {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          setTimeout(() => btn.classList.remove('is-added'), 1600);
        }
        openDrawer();
      })
      .catch((err) => {
        btn && btn.classList.remove('is-loading');
        alertInline(form, err.message);
      });
  }

  function alertInline(form, msg) {
    let el = form.querySelector('.buy__error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'buy__error';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'color:#b6462f;font-weight:600;margin-top:10px;font-size:.9rem';
      form.appendChild(el);
    }
    el.textContent = msg || 'Non è stato possibile aggiungere il prodotto. Riprova.';
  }

  /* ---------- Occhi degli animali che seguono il cursore ---------- */
  const pets = $$('.pet');
  if (pets.length && !reduced) {
    let target = null, queued = false;
    const look = () => {
      queued = false;
      if (!target) return;
      pets.forEach((svg) => {
        const r = svg.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        const cx = r.left + r.width / 2, cy = r.top + r.height * 0.6;
        const dx = target.x - cx, dy = target.y - cy;
        const d = Math.hypot(dx, dy) || 1;
        const m = Math.min(4.5, d / 40);
        const tx = (dx / d) * m, ty = (dy / d) * m * 0.7;
        $$('.pet__pupil', svg).forEach((p) => { p.style.transform = `translate(${tx.toFixed(2)}px, ${ty.toFixed(2)}px)`; });
      });
    };
    const set = (x, y) => { target = { x, y }; if (!queued) { queued = true; requestAnimationFrame(look); } };
    window.addEventListener('pointermove', (e) => set(e.clientX, e.clientY), { passive: true });
    window.addEventListener('vp:look', (e) => set(e.detail.x, e.detail.y));
  }

  /* ---------- Shopify theme editor ---------- */
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-reveal]', e.target).forEach((el) => el.classList.add('is-in'));
  });
})();
